import { DailyDriverReport } from '../../../models';
import { getCounts, getPayments, getDriver, getDailyReportOrder } from './getDailyReport';

export const getDriverDailyReport = (data: any): DailyDriverReport => {
  return {
    deliveries: {
      counts: getCounts(data.deliveries.counts),
      payments: getPayments(data.deliveries.payments),
    },
    pickups: {
      counts: getCounts(data.pickups.counts),
    },
    driver: getDriver(data.driver),
    orders: data.orders.map(getDailyReportOrder)
  };
}

